<nb-card
  [accent]="
    workingTask.priority >= 0
      ? priorities[workingTask.priority].status
      : 'default'
  "
>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div>
          <div class="link description">
            <p>{{ workingTask.title }}</p>
          </div>
          <div
            class="text-hint"
            *ngIf="
              mode != 'customer' &&
              (workingTask.customerId ||
                workingTask.supplierId ||
                workingTask.employeeId)
            "
          >
            <nb-icon
              icon="person-outline"
              [status]="
                workingTask.objectType === 'customer'
                  ? 'danger'
                  : workingTask.objectType === 'supplier'
                  ? 'warning'
                  : 'primary'
              "
            >
            </nb-icon>
            <span *ngIf="workingTask.customerId">
              {{ workingTask.customerName }}
            </span>
            <span *ngIf="workingTask.supplierId">
              {{ workingTask.supplierName }}
            </span>
            <span *ngIf="workingTask.employeeId">
              {{ workingTask.employeeName }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </nb-card-header>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-user-display
        *ngIf="workingTask.assignBy !== uid"
        [user]="workingTask.assignee"
        [mode]="'icon'"
        [size]="'small'"
      ></ngx-view-user-display>

      <ngx-view-user-display
        *ngIf="workingTask.assignBy === uid"
        [user]="workingTask.assignee"
        [mode]="'avatar'"
        [size]="'small'"
      ></ngx-view-user-display>

      <ngx-view-user-display
        [user]="workingTask.assignee"
        [size]="'small'"
      ></ngx-view-user-display>
    </div>

    <div>
      <button
        nbButton
        ghost
        size="tiny"
        [status]="
          workingTask.priority >= 0
            ? priorities[workingTask.priority].status
            : 'default'
        "
      >
        <nb-icon
          [icon]="
            workingTask.priority >= 0
              ? priorities[workingTask.priority].icon
              : 'eye-off-2-outline'
          "
        ></nb-icon>
        <span>
          {{
            workingTask.priority >= 0
              ? priorities[workingTask.priority].title
              : "N/A"
          }}
        </span>
      </button>
    </div>

    <!-- <ngx-view-time-ago
      [currentDate]="workingTask.issueDate"
    ></ngx-view-time-ago> -->

    <label class="text-hint">
      {{ workingTask.issueDate | date : "dd/MM/yyyy" }}
    </label>
  </nb-card-footer>
</nb-card>
